import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import LogRow from './LogRow';
import './style.scss';

class LogsTable extends PureComponent {
    state = {};

    renderLogsTable = (logData) => {
        const { literals } = this.props;
        return (
            <table className="integration-logs-table">
                <thead>
                    <tr>
                        <th className="w-100" />
                        <th className="w-200" />
                        <th className="w-200">
                            <Literal literal="common_date" />
                        </th>
                        <th>
                            <Literal
                                literal={
                                    literals['label_sync_result_integration'] ||
                                    'label_sync_result_integration'
                                }
                            />
                        </th>
                    </tr>
                </thead>
                <tbody>{this.renderLogRows(logData)}</tbody>
            </table>
        );
    };

    renderLogRows() {
        const { logData, integration, literals, integrationLogo } = this.props;
        let logRows = logData.logs.map((log, index) => {
            return (
                <LogRow
                    key={index}
                    log={log}
                    integration={integration}
                    literals={literals}
                    integrationLogo={integrationLogo}
                />
            );
        });
        return logRows;
    }

    render() {
        return <div className="integration-stats">{this.renderLogsTable()}</div>;
    }
}

export default LogsTable;
